<template>
  <div id="app">
    <v-app light>
      <v-toolbar color="white">
        <v-toolbar-title v-text="title"></v-toolbar-title>
      </v-toolbar>
    </v-app>
  </div>
</template>

<script>
export default {
  data: () => ({
    title: "DigitalProtokoll.no"
  }),
  computed: {},
  props: {
    source: String
  },
  mounted() {},
  methods: {}
};
</script>
